import preloader from "@/util/preloader";

export default  {
  install(Vue) {
    Vue.prototype.$preloader = preloader;
  },
};
